import { Vertical } from "../../types/verticalTypes";
import { VerticalIcon } from "../VerticalIcon";
import React from "react";

export const convertData = (data) => (
  data.map(item => {
    return {
      value: `${item.ip_id}`,
      label: `${item.ip}`,
      iconUrl: `${item.image_url}`,
      iconAlt: `${item.ip} cover`,
      tags: item.tags,
      originalData: { ...item, value: item.ip_id },
    };
  }).filter(item => item.value != null || item.label != null)
);

export const allVerticalOptions = [
  { label: "All", value: "all", iconName: "search" },
  { label: "Movies", value: Vertical.Movies, iconSvg: (<VerticalIcon vertical={Vertical.Movies} />) },
  { label: "Series", value: Vertical.Series, iconSvg: (<VerticalIcon vertical={Vertical.Series} />) },
  { label: "Games", value: Vertical.Games, iconSvg: (<VerticalIcon vertical={Vertical.Games} />) },
  { label: "Books", value: Vertical.Books, iconSvg: (<VerticalIcon vertical={Vertical.Books} />) },
  { label: "Anime", value: Vertical.Anime, iconSvg: (<VerticalIcon vertical={Vertical.Anime} />) },
  { label: "Manga", value: Vertical.Manga, iconSvg: (<VerticalIcon vertical={Vertical.Manga} />) },
  { label: "Franchises", value: Vertical.Franchises, iconSvg: (<VerticalIcon vertical={Vertical.Franchises} />) },
  { label: "Talent", value: Vertical.Talent, iconSvg: (<VerticalIcon vertical={Vertical.Talent} />) },
];